import { taApiClient } from '../utils/http-client';
import config from '../utils/config';
import ResourceManager from './resource.manager';

class PackagesSerivce extends ResourceManager {
	async getInterviewsPackages(params) {
		return await this.getResource(config.URIs.get_interviews_packages, { params });
	}

	async purchasePackage(packageId) {
		return await this.postResource(config.URIs.purchase_package.replace(/:packageId/g, packageId), {});
	}
}

export default new PackagesSerivce();
